<div class="modal-one-radio-container">
  <h2>{{ 'steps.tipsideWithModal.modalContent.title' | translate }}</h2>
  <div class="state-container">
    <p>{{ 'steps.tipsideWithModal.modalContent.state' | translate }}</p>
    <nz-badge [ngClass]="dataModal.badgeStatus" [nzText]="'steps.tipsideWithModal.' + dataModal.badgeStatus | translate" [nzStatus]="dataModal.badgeStatus"></nz-badge>
  </div>
  <p>{{ 'steps.tipsideWithModal.modalContent.subtitle' | translate }}</p>
  <div class="radio-container">
    <nz-radio-group [formControl]="choiceSelected">
      <div class="selector">
        @for (radio of dataModal.radioElement; track $index) {
          <label nz-radio [nzValue]="radio">{{ texts[$index] | translate }}</label>
        }
      </div>
    </nz-radio-group>
  </div>
  <div class="button-container">
    <ds-button class="button-exit" [text]="'steps.tipsideWithModal.modalContent.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="close()"></ds-button>
    <ds-button class="button-save" [text]="'steps.tipsideWithModal.modalContent.save' | translate" [width]="'small'" (click)="save()"></ds-button>
  </div>
</div>
